/**
 * Cancels in-flight cart / menu drawer open animations when the drawer is closed
 * early — without this, Be Yours leaves `mini-cart--opening` (or re-adds
 * `mini-cart--open` from a still-running 400ms RAF) on <body>, so the dim overlay
 * and its cross cursor stay after the panel has already slid away.
 *
 * Generation token: every open and every close bumps it; open timeouts and both
 * animation loops no-op if their token is stale. Close also clears the opening
 * class the stock close path never removed.
 *
 * Injected into layout/theme.liquid by theme/apply-brand.mjs.
 */
;(function () {
  function patch() {
    var Ctor = customElements.get('menu-drawer')
    if (!Ctor || Ctor.prototype._pareeDrawerPatched) return
    var proto = Ctor.prototype
    proto._pareeDrawerPatched = true

    proto.openMenuDrawer = function (summaryElement) {
      this._pareeDrawerGen = (this._pareeDrawerGen || 0) + 1
      var gen = this._pareeDrawerGen

      setScrollbarWidth()
      setHeaderBottomPosition()

      if (summaryElement) {
        summaryElement.setAttribute('aria-expanded', true)
        trapFocus(this.mainDetailsToggle, summaryElement)
      }

      document.body.classList.remove(this.classes.closing, this.classes.open)
      if (this.mainDetailsToggle) this.mainDetailsToggle.classList.remove('menu-closing')

      setTimeout(
        function () {
          if (gen !== this._pareeDrawerGen) return
          this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)
          document.body.addEventListener('click', this.onBodyClickEvent)
        }.bind(this),
      )

      document.body.classList.add(this.classes.opening)
      this.openAnimation()

      setTimeout(
        function () {
          if (gen !== this._pareeDrawerGen) return
          this.mainDetailsToggle.setAttribute('open', '')
          setTimeout(
            function () {
              if (gen !== this._pareeDrawerGen) return
              this.mainDetailsToggle.classList.add('menu-opening')
            }.bind(this),
            10,
          )
        }.bind(this),
      )
    }

    proto.closeMenuDrawer = function (event, elementToFocus) {
      if (event === undefined) return

      this._pareeDrawerGen = (this._pareeDrawerGen || 0) + 1

      this.mainDetailsToggle.querySelectorAll('details').forEach(function (details) {
        details.removeAttribute('open')
        details.classList.remove('menu-opening')
      })
      this.mainDetailsToggle.classList.remove('menu-opening')
      this.mainDetailsToggle.classList.add('menu-closing')
      removeTrapFocus(elementToFocus)

      document.body.removeEventListener('click', this.onBodyClickEvent)
      document.body.classList.remove(this.classes.open, this.classes.opening)
      document.body.classList.add(this.classes.closing)

      this.closeAnimation(this.mainDetailsToggle)
      this.dispatchEvent(new CustomEvent('close'))
      document.dispatchEvent(new CustomEvent('menudrawer:close'))
    }

    proto.openAnimation = function () {
      var gen = this._pareeDrawerGen
      var animationStart
      var self = this

      var handleAnimation = function (time) {
        if (gen !== self._pareeDrawerGen) return
        if (animationStart === undefined) animationStart = time
        if (time - animationStart < 400) {
          window.requestAnimationFrame(handleAnimation)
        } else {
          document.body.classList.remove(self.classes.opening)
          document.body.classList.add(self.classes.open)
        }
      }

      window.requestAnimationFrame(handleAnimation)
    }

    proto.closeAnimation = function (detailsElement) {
      var gen = this._pareeDrawerGen
      var animationStart
      var self = this

      var handleAnimation = function (time) {
        if (gen !== self._pareeDrawerGen) return
        if (animationStart === undefined) animationStart = time
        if (time - animationStart < 400) {
          window.requestAnimationFrame(handleAnimation)
        } else {
          if (detailsElement === self.mainDetailsToggle) {
            document.body.classList.remove(self.classes.closing)
            detailsElement.classList.remove('menu-closing')
          }
          detailsElement.removeAttribute('open')
          if (detailsElement.closest('details[open]')) {
            trapFocus(
              detailsElement.closest('details[open]'),
              detailsElement.querySelector('summary'),
            )
          }
        }
      }

      window.requestAnimationFrame(handleAnimation)
    }
  }

  if (customElements.get('menu-drawer')) patch()
  else customElements.whenDefined('menu-drawer').then(patch)
})()
